<template>
  <form>
    <div class="settings-top-bar" ref="optionsTopBar">
      <div class="top-bar">
       <p>
          <a class="btn btn-orange btn-icon" :title="$t('general.back')" @click.prevent="backButton"><i class="ti-arrow-left"></i></a>
       </p>
       <p class="d-inline-flex">
          <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" v-if="$route.params.id" @click.prevent="deleteOrderScreen" style="padding: 7px 10px; margin-right: 20px;">
            <img src="/static/img/icons/icon-close.png">
            {{$t('general.delete')}}
          </a>
          <button type="submit" class="btn btn-success btn-icon mar-rt-10 save"  @click.prevent="validate" :title="$t('general.save') + ' ' + $t('settingUsers.single')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>
    <div class="row mar-to-15">
      <div class="col-md-12">
        <div class="card" style="width:100%; margin: 0 0 20px;">
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg><!---->
            </div>
          </div>
          <div class="card-content">
            <p class="text-danger" v-if="errors.has('error')">
              {{ getError('error') }}
            </p>
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>ID</label>
                      <input type="number"
                        disabled
                        placeholder="ID"
                        v-model="model.id"
                        class="form-control">
                    </div>
                  </div>
                  <div class="col-md-6" v-if="model.id">
                    <div class="form-group">
                      <label>{{$t('settingTable.loginCode')}}</label>
                      <input
                        type="text"
                        name="token"
                        disabled="true"
                        :placeholder="$t('settingTable.loginCode')"
                        :value="model.company_id + '.' + model.id"
                        class="form-control">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>Name</label>
                  <input type="text"
                    placeholder="Name"
                    v-validate="modelValidate.name"
                    v-model="model.name"
                    class="form-control">
                </div>
                <div class="form-group">
                  <label>{{$t('settingTable.location')}}</label>
                  <select
                    name="location"
                    class="form-control"
                    v-validate="modelValidate.location_id"
                    v-model="model.location_id"
                    @change="changeLocation()"
                  >
                    <option value="null" disabled>{{$t('general.none')}}</option>
                    <option
                      v-for="(loc) in locations"
                      :value="loc.id"
                      :label="loc.name"
                      :key="loc.id">
                    </option>
                  </select>
                </div>
                <div class="form-group mar-to-15 label-input">
                  <label>{{$t('settingTable.is_dispatch')}}</label>
                  <p-switch v-model="model.is_dispatch" type="success"></p-switch>
                </div>
                <div class="form-group mar-to-15 label-input" v-if="model.is_dispatch">
                  <label>{{$t('settingTable.sync_products_from_all_locations')}}</label>
                  <p-switch v-model="model.sync_products_from_all_locations" type="success"></p-switch>
                </div>
                <div class="form-group" v-if="model.is_dispatch">
                  <label>{{$t('settingTable.sync_location_ids')}}</label>
                  <el-select
                    key="sync_location_ids"
                    name="sync_location_ids"
                    v-model="model.sync_location_ids"
                    multiple
                    filterable
                    default-first-option
                    style="width: 100%; color: #fff;"
                    :placeholder="$t('general.add')">
                    <template v-for="item in locations">
                      <el-option
                        :value="Number(item.id)"
                        :label="item.name"
                        :key="item.id">
                      </el-option>
                    </template>
                  </el-select>
                </div>
                <div class="form-group mar-to-15 label-input" v-if="!model.is_dispatch">
                  <label>{{$t('settingTable.use_table_maps')}}</label>
                  <p-switch v-model="model.use_table_maps" type="success"></p-switch>
                </div>
                <div class="form-group" v-if="!model.is_dispatch">
                  <label>{{$t('settingTable.maps')}}</label>
                  <el-select
                    key="methods"
                    name="methods"
                    v-model="model.table_maps_ids"
                    multiple
                    filterable
                    default-first-option
                    :disabled="!model.use_table_maps"
                    style="width: 100%; color: #fff;"
                    :placeholder="$t('general.add')">
                    <el-option
                      :value="null"
                      :label="$t('general.none')"
                      :key="0" disabled>
                    </el-option>
                    <template v-for="item in table_maps">
                          <el-option
                            :value="item.id"
                            :label="item.name">
                          </el-option>
                    </template>
                  </el-select>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>{{$t('settingTable.series')}}</label>
                      <input
                        type="text"
                        name="series"
                        :placeholder="$t('settingTable.series')"
                        v-validate="modelValidate.series"
                        v-model="model.series"
                        class="form-control">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>{{$t('settingTable.start_number')}}</label>
                      <input
                        type="number"
                        name="start_number"
                        :placeholder="$t('settingTable.start_number')"
                        v-validate="modelValidate.start_number"
                        v-model="model.start_number"
                        class="form-control">
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>{{$t('settingTable.serverIp')}}</label>
                      <input
                        type="text"
                        name="server_ip"
                        :placeholder="$t('settingTable.serverIpExample')"
                        v-validate="modelValidate.server_ip"
                        v-model="model.server_ip"
                        class="form-control">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>{{$t('settingTable.printerIp')}}</label>
                      <input
                        type="text"
                        name="printer_ip"
                        :placeholder="$t('settingTable.printerIpExample')"
                        v-model="model.printer_ip"
                        class="form-control">
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>{{$t('settingTable.fiscalPrinter')}}</label>
                      <select
                        name="fiscal_printer_id"
                        class="form-control"
                        v-model="model.fiscal_printer_id"
                      >
                        <option :value="null">{{$t('general.none')}}</option>
                        <option
                          v-for="(el) in fiscalPrinter"
                          :value="el.id"
                          :label="el.series"
                          :key="el.id">
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>{{$t('settingTable.cantar')}}</label>
                      <select
                        name="cantar_id"
                        class="form-control"
                        v-model="model.cantar_id"
                      >
                        <option :value="null">{{$t('general.none')}}</option>
                        <option
                          v-for="(el) in cantare"
                          :value="el.id"
                          :label="el.name"
                          :key="el.id">
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <!-- <div v-if="$route.params.id && !model.token" style="padding-left: 0 !important">
                  <label>{{$t('settingTable.loginCode')}}</label>
                  <input
                    type="text"
                    name="token"
                    disabled="true"
                    :placeholder="$t('settingTable.loginCode')"
                    :value="model.company_id + '.' + model.id"
                    class="form-control">
                </div> -->

                <!-- <div v-if="$route.params.id && model.token">
                  <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" @click.prevent="deleteToken" style="padding: 7px 10px; margin-right: 20px;">
                    <img src="/static/img/icons/icon-close.png">
                    {{$t('settingTable.disableAuth')}}
                  </a>
                </div> -->

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12" v-if="model.id">
        <div class="card" style="width:100%; margin: 0;">
          <div class="card-content" style="width:100%; margin: 0; display: flex; flex-direction: column; flex-wrap: nowrap; justify-content: start;">

            <!-- Tables & users -->
            <div class="pos-settings-group" v-if="!model.is_dispatch">
              <h5 class="section-title">{{ $t('settingTable.group_tables_users') }}</h5>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group mar-to-15 label-input">
                    <label>{{$t('settingTable.allow_tables_access_only_if_assigned')}}</label>
                    <p-switch v-model="model.allow_tables_access_only_if_assigned" type="success"></p-switch>
                  </div>
                  <div class="form-group mar-to-15 label-input">
                    <label>{{$t('settingTable.disable_seats')}}</label>
                    <p-switch v-model="model.disable_seats" type="success"></p-switch>
                  </div>
                  <div class="form-group mar-to-15 label-input">
                    <label>{{$t('settingTable.disable_pager')}}</label>
                    <p-switch v-model="model.disable_pager" type="success"></p-switch>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mar-to-15 label-input">
                    <label>{{$t('settingTable.table_for_one_user')}}</label>
                    <select class="form-control color-option-default"
                        name="table_for_one_user"
                        v-model="model.table_for_one_user">
                          <option :key="null" :value="null">{{$t('settingTable.as_useer')}}</option>
                          <option :key="false" :value="false">{{$t('settingTable.inactiv')}}</option>
                          <option :key="true" :value="true">{{$t('settingTable.activ')}}</option>
                      </select>
                  </div>
                  <div class="form-group mar-to-15 label-input">
                    <label>{{$t('settingTable.sound_new_order')}}</label>
                    <p-switch v-model="model.sound_new_order" type="success"></p-switch>
                  </div>
                  <div class="form-group mar-to-15 label-input">
                    <label>{{$t('settingTable.sound_notification')}}</label>
                    <p-switch v-model="model.sound_notification" type="success"></p-switch>
                  </div>
                </div>
              </div>
            </div>

            <!-- Order types -->
            <div class="pos-settings-group">
              <h5 class="section-title">{{ $t('settingTable.group_order_types') }}</h5>
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group label-input" :class="{ 'is-disabled': model.is_dispatch }">
                    <label>{{ orderTypeSwitchLabel('disable_eat_in') }}</label>
                    <p-switch :value="orderTypeSwitchValue('disable_eat_in')" :disabled="model.is_dispatch" @input="onOrderTypeSwitchInput('disable_eat_in', $event)" type="success"></p-switch>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group label-input" :class="{ 'is-disabled': model.is_dispatch }">
                    <label>{{ orderTypeSwitchLabel('disable_delivery') }}</label>
                    <p-switch :value="orderTypeSwitchValue('disable_delivery')" :disabled="model.is_dispatch" @input="onOrderTypeSwitchInput('disable_delivery', $event)" type="success"></p-switch>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group label-input" :class="{ 'is-disabled': model.is_dispatch }">
                    <label>{{ orderTypeSwitchLabel('disable_pick_up') }}</label>
                    <p-switch :value="orderTypeSwitchValue('disable_pick_up')" :disabled="model.is_dispatch" @input="onOrderTypeSwitchInput('disable_pick_up', $event)" type="success"></p-switch>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group label-input" :class="{ 'is-disabled': model.is_dispatch }">
                    <label>{{ orderTypeSwitchLabel('disable_drive_in') }}</label>
                    <p-switch :value="orderTypeSwitchValue('disable_drive_in')" :disabled="model.is_dispatch" @input="onOrderTypeSwitchInput('disable_drive_in', $event)" type="success"></p-switch>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{$t('settingTable.default_method')}}</label>
                    <select
                      name="location"
                      class="form-control"
                      v-model="model.default_method"
                    >
                      <option value="null">{{$t('general.none')}}</option>
                      <template v-for="(loc) in allMethods">
                        <option
                          v-if="
                                !(loc.id == 1 && model.disable_eat_in) &&
                                !(loc.id == 2 && model.disable_delivery) &&
                                !(loc.id == 3 && model.disable_pick_up) &&
                                !(loc.id == 4 && model.disable_drive_in)
                              "
                          :key="loc.id"
                          :value="loc.id"
                          :label="loc.name"
                          >
                        </option>
                      </template>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <!-- Closing orders -->
            <div class="pos-settings-group">
              <h5 class="section-title">{{ $t('settingTable.group_closing_orders') }}</h5>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group mar-to-15 label-input">
                    <label>{{$t('settingTable.allowClosingOrdersWithoutReceipt')}}</label>
                    <p-switch v-model="model.allow_closing_orders_without_receipt" type="success"></p-switch>
                  </div>
                  <div class="form-group mar-to-15 label-input">
                    <label>{{$t('settingTable.allow_closing_orders_without_driver')}}</label>
                    <p-switch v-model="model.allow_closing_orders_without_driver" type="success"></p-switch>
                  </div>
                  <div class="form-group mar-to-15 label-input">
                    <label>{{$t('settingTable.close_order')}}</label>
                    <p-switch v-model="model.close_order" type="success"></p-switch>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mar-to-15 label-input">
                    <label>{{$t('settingTable.allow_change_driver')}}</label>
                    <p-switch v-model="model.allow_change_driver" type="success"></p-switch>
                  </div>
                  <div class="form-group mar-to-15 label-input">
                    <label>{{$t('settingTable.allow_print_note')}}</label>
                    <p-switch v-model="model.allow_print_note" type="success"></p-switch>
                  </div>
                  <div class="form-group">
                    <label>{{$t('settingTable.not_allowed_order_statuses')}}</label>
                    <el-select
                      key="not_allowed_order_statuses"
                      name="not_allowed_order_statuses"
                      v-model="model.not_allowed_order_statuses"
                      multiple
                      collapse-tags
                      filterable
                      default-first-option
                      style="width: 100%; color: #fff;"
                      :placeholder="$t('general.none')"
                      >
                      <template v-for="item in auto_print_receipt_on_status_all">
                        <el-option
                          :value="item.id"
                          :label="$t('ordersStatus.' + item.id)"
                          :key="item.id">
                        </el-option>
                      </template>
                    </el-select>
                  </div>
                </div>
              </div>
            </div>

            <!-- Payments & terminals -->
            <div class="pos-settings-group">
              <h5 class="section-title">{{ $t('settingTable.group_payments') }}</h5>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group mar-to-15 label-input">
                    <label>{{$t('settingTable.disable_tips')}}</label>
                    <p-switch v-model="model.disable_tips" type="success"></p-switch>
                  </div>
                  <div class="form-group mar-to-15 label-input">
                    <label>{{$t('settingTable.disable_ballance')}}</label>
                    <p-switch v-model="model.disable_ballance" type="success"></p-switch>
                  </div>
                  <div class="form-group">
                    <label>{{$t('settingTable.default_sort_checkout_buttons')}}</label>
                    <el-select
                      key="methods"
                      name="methods"
                      v-model="model.default_sort_checkout_buttons"
                      multiple
                      filterable
                      default-first-option
                      :disabled="model.is_dispatch"
                      style="width: 100%; color: #fff;"
                      :placeholder="$t('general.add')"
                      @change="handleSelectionChange">
                      <el-option
                        :value="null"
                        :label="$t('general.none')"
                        :key="0" disabled>
                      </el-option>
                      <template v-for="item in availableCheckoutButtons">
                            <el-option
                              :value="item.name"
                              :label="item.name"
                              :key="item.id">
                            </el-option>
                      </template>
                    </el-select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mar-to-15 label-input">
                    <label>{{$t('settingTable.has_bank_terminal')}}</label>
                    <p-switch v-model="model.has_bank_terminal" type="success"></p-switch>
                  </div>
                  <div class="form-group mar-to-15 label-input">
                    <label>{{$t('settingTable.use_fiscal_net_at_modern_payment')}}</label>
                    <p-switch v-model="model.use_fiscal_net_at_modern_payment" type="success"></p-switch>
                  </div>
                  <div class="form-group mar-to-15 label-input">
                    <label>{{$t('settingTable.has_integrated_bank_terminal')}}</label>
                    <p-switch v-model="model.has_integrated_bank_terminal" type="success"></p-switch>
                  </div>
                </div>
              </div>
              <div class="row" v-if="model.has_integrated_bank_terminal">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{$t('settingTable.server_ip')}}</label>
                    <input type="text"
                            name="integrated_bank_pos_server_ip"
                            data-vv-as="integrated_bank_pos_server_ip"
                            :placeholder="$t('settingTable.server_ip')"
                            v-model="model.integrated_bank_pos_server_ip"
                            class="form-control">
                  </div>
                  <div class="form-group">
                    <label>{{$t('settingTable.type')}}</label>
                    <select name="pos_type_id" class="form-control"
                                v-model="model.pos_type_id">
                      <option :value="null"
                              :label="''"
                              :key="0"></option>
                      <option v-for="z in posOptions"
                              :value="z.id"
                              :label="z.name"
                              :key="z.id">
                      </option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>{{$t('settingTable.host')}}</label>
                    <input type="text"
                            name="integrated_bank_pos_host"
                            data-vv-as="integrated_bank_pos_host"
                            :placeholder="$t('settingTable.host')"
                            v-model="model.integrated_bank_pos_host"
                            class="form-control">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{$t('settingTable.port')}}</label>
                    <input type="text"
                            name="integrated_bank_pos_port"
                            data-vv-as="integrated_bank_pos_port"
                            :placeholder="$t('settingTable.port')"
                            v-model="model.integrated_bank_pos_port"
                            class="form-control">
                  </div>
                  <div class="form-group">
                    <label>TID/MID</label>
                    <input type="text"
                            name="integrated_bank_pos_tid_mid"
                            data-vv-as="integrated_bank_pos_tid_mid"
                            placeholder="TID/MID"
                            v-model="model.integrated_bank_pos_tid_mid"
                            class="form-control">
                  </div>
                </div>
              </div>
            </div>

            <!-- Fiscal & printing -->
            <div class="pos-settings-group">
              <h5 class="section-title">{{ $t('settingTable.group_fiscal_printing') }}</h5>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group mar-to-15 label-input">
                    <label>{{$t('settingTable.allow_fiscal')}}</label>
                    <p-switch v-model="model.allow_fiscal" type="success"></p-switch>
                  </div>
                  <div class="form-group mar-to-15 label-input">
                    <label>{{$t('settingTable.use_block_actions_after_print')}}</label>
                    <p-switch v-model="model.use_block_actions_after_print" type="success"></p-switch>
                  </div>
                  <div class="form-group mar-to-15 label-input">
                    <label>{{$t('settingTable.block_z_until_all_orders_fiscalized')}}</label>
                    <p-switch v-model="model.block_z_until_all_orders_fiscalized" type="success"></p-switch>
                  </div>
                  <div class="form-group mar-to-15 label-input">
                    <label>{{$t('settingTable.stop_print_section')}}</label>
                    <p-switch v-model="model.stop_print_section" type="success"></p-switch>
                  </div>
                  <div class="form-group mar-to-15 label-input">
                    <label>{{$t('settingTable.allow_change_payment_type_on_fiscalization')}}</label>
                    <p-switch v-model="model.allow_change_payment_type_on_fiscalization" type="success"></p-switch>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mar-to-15 label-input">
                    <label>{{$t('settingTable.auto_print_receipt')}}</label>
                    <p-switch v-model="model.auto_print_receipt" @input="changeAutoPrintReceipt" type="success"></p-switch>
                  </div>
                  <div class="form-group">
                    <label>{{$t('settingTable.auto_print_receipt_on_metods')}}</label>
                    <el-select
                      key="auto_print_receipt_on_metods"
                      name="auto_print_receipt_on_metods"
                      v-model="model.auto_print_receipt_on_metods"
                      multiple
                      collapse-tags
                      :disabled="!model.auto_print_receipt"
                      filterable
                      default-first-option
                      style="width: 100%; color: #fff;"
                      :placeholder="$t('general.none')"
                      >
                      <el-option
                        :value="null"
                        :label="$t('general.none')"
                        :key="0" disabled>
                      </el-option>
                      <template v-for="item in auto_print_receipt_on_metods_all">
                            <el-option
                              :value="item.id"
                              :label="$t('paymentTypes.' + item.id)"
                              :key="item.id">
                            </el-option>
                      </template>
                    </el-select>
                  </div>
                  <div class="form-group">
                    <label>{{$t('settingTable.auto_print_receipt_on_status')}}</label>
                    <el-select
                      key="auto_print_receipt_on_status"
                      name="auto_print_receipt_on_status"
                      v-model="model.auto_print_receipt_on_status"
                      multiple
                      collapse-tags
                      :disabled="!model.auto_print_receipt"
                      filterable
                      default-first-option
                      style="width: 100%; color: #fff;"
                      :placeholder="$t('general.none')"
                      >
                      <el-option
                        :value="null"
                        :label="$t('general.none')"
                        :key="0" disabled>
                      </el-option>
                      <template v-for="item in auto_print_receipt_on_status_all">
                            <el-option
                              :value="item.id"
                              :label="$t('ordersStatus.' + item.id)"
                              :key="item.id">
                            </el-option>
                      </template>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{$t('settingTable.allowed_fiscal_payment_methods')}}</label>
                    <el-select
                      key="allowed_fiscal_payment_methods"
                      name="allowed_fiscal_payment_methods"
                      v-model="model.allowed_fiscal_payment_methods"
                      multiple
                      :collapse-tags="!model.is_dispatch"
                      filterable
                      default-first-option
                      :disabled="model.is_dispatch"
                      style="width: 100%; color: #fff;"
                      :placeholder="$t('general.all')"
                      >
                      <template v-for="item in availableFiscalPaymentMethods">
                        <el-option
                          :value="item.id"
                          :label="item.label || $t('paymentTypes.' + item.id)"
                          :key="item.id">
                        </el-option>
                      </template>
                    </el-select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{$t('settingTable.auto_print_fiscal_on_status')}}</label>
                    <el-select
                      key="auto_print_fiscal_on_status"
                      name="auto_print_fiscal_on_status"
                      v-model="model.auto_print_fiscal_on_status"
                      multiple
                      filterable
                      default-first-option
                      style="width: 100%; color: #fff;"
                      :placeholder="$t('general.add')"
                      >
                      <el-option
                        :value="null"
                        :label="$t('general.none')"
                        :key="0" disabled>
                      </el-option>
                      <template v-for="item in auto_print_all_statuses">
                            <el-option
                              :value="item.name"
                              :label="item.name">
                            </el-option>
                      </template>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{$t('settingTable.auto_print_fiscal_on_source')}}</label>
                    <el-select
                      key="auto_print_fiscal_on_source"
                      name="auto_print_fiscal_on_source"
                      v-model="model.auto_print_fiscal_on_source"
                      multiple
                      filterable
                      default-first-option
                      style="width: 100%; color: #fff;"
                      :placeholder="$t('general.add')"
                      >
                      <el-option
                        :value="null"
                        :label="$t('general.none')"
                        :key="0" disabled>
                      </el-option>
                      <template v-for="item in auto_print_all_sources">
                            <el-option
                              :value="item.name"
                              :label="item.name">
                            </el-option>
                      </template>
                    </el-select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{$t('settingTable.auto_print_fiscal_on_payment_methods')}}</label>
                    <el-select
                      key="auto_print_fiscal_on_payment_methods"
                      name="auto_print_fiscal_on_payment_methods"
                      v-model="model.auto_print_fiscal_on_payment_methods"
                      multiple
                      filterable
                      default-first-option
                      style="width: 100%; color: #fff;"
                      :placeholder="$t('general.all')"
                      >
                      <template v-for="item in autoFiscalPaymentMethods">
                        <el-option
                          :value="item.id"
                          :label="$t('paymentTypes.' + item.id)"
                          :key="item.id">
                        </el-option>
                      </template>
                    </el-select>
                    <small class="d-block text-muted mt-2">{{$t('settingTable.auto_print_fiscal_on_payment_methods_help')}}</small>
                  </div>
                </div>
              </div>
            </div>

            <!-- Display & interface -->
            <div class="pos-settings-group">
              <h5 class="section-title">{{ $t('settingTable.group_display') }}</h5>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group mar-to-15 label-input">
                    <label>{{$t('settingTable.dispalyProductsImage')}}</label>
                    <p-switch v-model="model.display_products_image" type="success"></p-switch>
                  </div>
                  <div class="form-group mar-to-15 label-input">
                    <label>{{$t('settingTable.disable_required_options')}}</label>
                    <p-switch v-model="model.disable_required_options" type="success"></p-switch>
                  </div>
                  <div class="form-group">
                    <label>{{$t('settingTable.lock_screen_timeout_min')}}</label>
                    <input
                      type="text"
                      name="lock_screen_timeout_min"
                      v-model="model.lock_screen_timeout_min"
                      maxlength="3"
                      @input="model.lock_screen_timeout_min = $event.target.value.replace(/[^0-9]/g, '').slice(0, 3)"
                      class="form-control">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="menu_orientation">{{$t('settingTable.menu_orientation')}}</label>
                    <select class="form-control color-option-default"
                      name="menu_orientation"
                      v-model="model.menu_orientation">
                        <option v-for="(item, index) in menuOrientation"
                                :key="index"
                                :value="index">
                          {{ $t('settingTable.' + item) }}
                        </option>
                    </select>
                  </div>
                  <BackgroundColorPicker :title="$t('settingsWeb.background_color')" :color="model.background_color" @color-change="updateColor"></BackgroundColorPicker>
                </div>
              </div>
            </div>

            <!-- Reports -->
            <div class="pos-settings-group">
              <h5 class="section-title">{{ $t('settingTable.group_reports') }}</h5>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group mar-to-15 label-input">
                    <label>{{$t('settingTable.set_logged_user_in_reports')}}</label>
                    <p-switch v-model="model.set_logged_user_in_reports" type="success"></p-switch>
                  </div>
                  <div class="form-group mar-to-15 label-input">
                    <label>{{$t('settingTable.comment_for_virament')}}</label>
                    <p-switch v-model="model.comment_for_virament" type="success"></p-switch>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{$t('pos.default_interval_raport')}}</label>
                    <el-select
                      key="default_interval_raport"
                      name="default_interval_raport"
                      v-model="model.default_interval_raport"
                      style="width: 100%; color: #fff;"
                      :placeholder="$t('general.add')"
                      >
                      <template v-for="item in default_intervals_raport">
                            <el-option
                              :value="item.id"
                              :label="item.name">
                            </el-option>
                      </template>
                    </el-select>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import Vue from 'vue'
  // import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker, Select} from 'element-ui'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import BackgroundColorPicker from 'src/components/UIComponents/BackgroundColorPicker.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)
  Vue.use(Select)

  export default {
    components: {
      PSwitch,
      BackgroundColorPicker,
      [Button.name]: Button,
      [Input.name]: Input,
      [Select.name]: Select
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    created () {
      this.apiUrl = process.env.API_BASE_URL
      this.getData()
    },
    computed: {
      selectedPosOption () {
        if (!this.model.pos_type_id) {
          return null
        }
        return this.posOptions.find(pos => pos.id === this.model.pos_type_id)
      },
      dispatchFiscalPaymentMethods () {
        return [
          { id: 'CASH', label: 'Cash' },
          { id: 'CARD_POS', label: 'Card' },
          { id: 'POS', label: 'Pos Mobil' }
        ]
      },
      dispatchFiscalPaymentMethodIds () {
        return this.dispatchFiscalPaymentMethods.map((item) => item.id)
      },
      dispatchCheckoutButtonNames () {
        return ['Cash', 'Card', 'Pos Mobil']
      },
      autoFiscalPaymentMethods () {
        // CARD is an online card payment (e.g. EuPlatesc), distinct from ONLINE.
        return [{ id: 'CARD' }].concat(this.auto_print_receipt_on_metods_all)
      },
      availableFiscalPaymentMethods () {
        if (!this.model.is_dispatch) {
          return this.auto_print_receipt_on_metods_all
        }
        return this.dispatchFiscalPaymentMethods
      },
      availableCheckoutButtons () {
        if (!this.model.is_dispatch) {
          return this.checkout_buttons
        }
        const fromList = this.checkout_buttons.filter(
          (item) => this.dispatchCheckoutButtonNames.indexOf(item.name) !== -1
        )
        const names = fromList.map((item) => item.name)
        const extras = []
        this.dispatchCheckoutButtonNames.forEach((name, index) => {
          if (names.indexOf(name) === -1) {
            extras.push({ id: 100 + index, name: name })
          }
        })
        return fromList.concat(extras)
      }
    },
    watch: {
      'model.pos_type_id' (newValue) {
        if (newValue) {
          const selectedOption = this.posOptions.find(pos => pos.id === newValue)
          if (selectedOption) {
            this.model.integrated_bank_pos_id = selectedOption.id
            this.model.integrated_bank_pos_name = selectedOption.name
          }
        } else {
          // Clear all fields if no option is selected
          this.model.integrated_bank_pos_id = null
          this.model.integrated_bank_pos_name = null
          this.model.integrated_bank_pos_port = null
          this.model.integrated_bank_pos_tid_mid = null
        }
      },
      'model.is_dispatch' (newValue) {
        if (newValue) {
          this.applyDispatchModeDefaults()
        } else {
          this.model.sync_products_from_all_locations = false
          this.model.sync_location_ids = []
          this.pendingSyncLocationIds = []
        }
      }
    },
    data () {
      return {
        id: this.value || this.tableId,
        locations: [],
        pendingSyncLocationIds: [],
        table_maps: [],
        fiscalPrinter: [],
        cantare: [],
        model: {
          'id': 0,
          'name': null,
          'location_id': null,
          'server_ip': null,
          'printer_ip': null,
          'table_maps_ids': [],
          'use_table_maps': false,
          'has_integrated_bank_terminal': false,
          'pos_type_id': null,
          'integrated_bank_pos_id': null,
          'integrated_bank_pos_name': null,
          'integrated_bank_pos_port': null,
          'integrated_bank_pos_tid_mid': null,
          'allow_closing_orders_without_receipt': false,
          'allow_closing_orders_without_driver': false,
          'allow_fiscal': true,
          'use_block_actions_after_print': false,
          'allowed_fiscal_payment_methods': [],
          'auto_print_fiscal_on_payment_methods': [],
          'allow_change_driver': false,
          'allow_print_note': false,
          'not_allowed_order_statuses': [],
          'is_dispatch': false,
          'sync_products_from_all_locations': false,
          'sync_location_ids': []
        },
        modelValidate: {
          name: {required: true},
          server_ip: {required: true},
          location_id: {required: true}
        },
        loading: true,
        auto_print_receipt_on_metods_all: [
          { 'id': 'CASH' },
          { 'id': 'CARD_POS' },
          { 'id': 'POS' },
          { 'id': 'GLOVO_CARD' },
          { 'id': 'GLOVO_CASH' },
          { 'id': 'WOLT_CARD' },
          { 'id': 'WOLT_CASH' },
          { 'id': 'BOLT_CARD' },
          { 'id': 'BOLT_CASH' },
          { 'id': 'ONLINE' }
        ],
        auto_print_receipt_on_status_all: [
          { 'id': 'NEW' },
          { 'id': 'PROCESSING' },
          { 'id': 'PREPARED' },
          { 'id': 'DELIVERED' },
          { 'id': 'CANCELED' }
        ],
        auto_print_all_statuses: [
          {
            'id': 'NEW',
            'name': 'NEW'
          },
          {
            'id': 'PROCESSING',
            'name': 'PROCESSING'
          },
          {
            'id': 'PREPARED',
            'name': 'PREPARED'
          }
        ],
        default_intervals_raport: [
          {
            'id': null,
            'name': this.$t('pos.default_intervals_raport0')
          },
          {
            'id': 1,
            'name': this.$t('pos.default_intervals_raport1')
          },
          {
            'id': 2,
            'name': this.$t('pos.default_intervals_raport2')
          }
        ],
        auto_print_all_sources: [
          {
            'id': 'GLOVO',
            'name': 'GLOVO'
          },
          {
            'id': 'BOLT',
            'name': 'BOLT'
          },
          {
            'id': 'WOLT',
            'name': 'WOLT'
          },
          {
            'id': 'APPLICATION',
            'name': 'APPLICATION'
          },
          {
            'id': 'QR',
            'name': 'QR'
          }
        ],
        checkout_buttons: [
          {
            'id': 1,
            'name': 'Cash'
          },
          {
            'id': 2,
            'name': 'Card'
          },
          {
            'id': 3,
            'name': 'Protocol'
          },
          {
            'id': 4,
            'name': 'Modern'
          },
          {
            'id': 5,
            'name': 'Discount'
          },
          {
            'id': 6,
            'name': 'Coupons'
          },
          {
            'id': 7,
            'name': 'Tva'
          }
        ],
        allMethods: [
          {
            'id': 1,
            'name': 'Eat in'
          },
          {
            'id': 2,
            'name': 'Delivery'
          },
          {
            'id': 3,
            'name': 'Pick up'
          },
          {
            'id': 4,
            'name': 'Drive in'
          }
        ],
        colors: {
          defult: '#c850c0',
          black: '#000'
        },
        menuOrientation: ['horizontal', 'vertical'],
        posOptions: [
          {
            'id': 1,
            'name': 'Ingenico 3200 (bt)',
            'ip': true,
            'port': true,
            'tid_mid': true
          },
          {
            'id': 2,
            'name': 'Ingenico 3200 (unicredit)',
            'ip': false,
            'port': true,
            'tid_mid': true
          },
          {
            'id': 3,
            'name': 'Ingenico 3200 (raiffeisen)',
            'ip': false,
            'port': true,
            'tid_mid': true
          },
          {
            'id': 4,
            'name': 'Viva Wallet',
            'ip': false,
            'port': true,
            'tid_mid': true
          }
        ]
      }
    },
    methods: {
      changeAutoPrintReceipt () {
        if (!this.model.auto_print_receipt) {
          this.model.auto_print_receipt_on_metods = null
          this.model.auto_print_receipt_on_status = null
        }
      },
      handleSelectionChange (val) {
        if (val.length > 4) {
          val.pop()
          this.$nextTick(() => {
            this.model.default_sort_checkout_buttons = val
          })
        }
      },
      changeDisableMethods (method) {
        if (this.model[method]) {
          this.model.default_method = null
        }
      },
      // In dispatch mode switches show "order type enabled" (ON = available).
      // Stored fields remain disable_* (true = stopped).
      orderTypeSwitchValue (disableKey) {
        if (this.model.is_dispatch) {
          return !this.model[disableKey]
        }
        return !!this.model[disableKey]
      },
      orderTypeSwitchLabel (disableKey) {
        if (!this.model.is_dispatch) {
          return this.$t('settingTable.' + disableKey)
        }
        const labels = {
          disable_eat_in: 'Eat In',
          disable_delivery: 'Delivery',
          disable_pick_up: 'Pick Up',
          disable_drive_in: 'Drive In'
        }
        return labels[disableKey] || this.$t('settingTable.' + disableKey)
      },
      onOrderTypeSwitchInput (disableKey, value) {
        if (this.model.is_dispatch) {
          this.$nextTick(() => {
            this.applyDispatchOrderTypes()
          })
          return
        }
        this.model[disableKey] = value
        this.changeDisableMethods(disableKey)
      },
      applyDispatchOrderTypes () {
        // Delivery + Pick Up available; Eat In + Drive In stopped.
        this.model.disable_eat_in = true
        this.model.disable_delivery = false
        this.model.disable_pick_up = false
        this.model.disable_drive_in = true
        if (this.model.default_method === 1 || this.model.default_method === 4) {
          this.model.default_method = 2
        }
      },
      applyDispatchModeDefaults () {
        this.model.use_table_maps = false
        this.model.table_maps_ids = []
        this.applyDispatchOrderTypes()
        this.model.allowed_fiscal_payment_methods = this.dispatchFiscalPaymentMethodIds.slice()
        this.model.default_sort_checkout_buttons = this.dispatchCheckoutButtonNames.slice()
      },
      copyToClipboard (textToCopy) {
        textToCopy = textToCopy.replace(/\s/g, '')
        this.$copyText(textToCopy)
      },
      normalizeSyncLocationIdsForSelect (ids) {
        if (!Array.isArray(ids)) {
          return []
        }
        const asNumericIds = () => {
          const normalized = []
          ids.forEach((raw) => {
            if (raw == null || raw === '') {
              return
            }
            const asNum = Number(raw)
            if (!Number.isNaN(asNum) && asNum > 0) {
              normalized.push(asNum)
            }
          })
          return [...new Set(normalized)]
        }
        // Options not loaded yet — keep numeric ids so we do not wipe the selection.
        if (!this.locations || !this.locations.length) {
          return asNumericIds()
        }
        const byToken = {}
        const byId = {}
        ;(this.locations || []).forEach((loc) => {
          if (loc.token) {
            byToken[loc.token] = Number(loc.id)
          }
          byId[Number(loc.id)] = Number(loc.id)
        })
        const normalized = []
        ids.forEach((raw) => {
          if (raw == null || raw === '') {
            return
          }
          const asNum = Number(raw)
          if (!Number.isNaN(asNum) && asNum > 0 && byId[asNum]) {
            normalized.push(asNum)
            return
          }
          if (typeof raw === 'string' && byToken[raw]) {
            normalized.push(byToken[raw])
          }
        })
        return [...new Set(normalized)]
      },
      applyPendingSyncLocationIds () {
        const pending = Array.isArray(this.pendingSyncLocationIds)
          ? this.pendingSyncLocationIds
          : this.model.sync_location_ids
        if (!Array.isArray(pending)) {
          this.model.sync_location_ids = []
          return
        }
        this.model.sync_location_ids = this.normalizeSyncLocationIdsForSelect(pending)
      },
      getData () {
        var id = this.id || this.route.params.id
        this.pendingSyncLocationIds = []
        if (id) {
          let data = {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany')
          }
          this.apiRequest('/pos/' + id, 'GET', data, (response) => {
            if (response.status) {
              // Declare defaults before Vue observes the replacement model.
              const pos = response.data.pos
              this.model = Object.assign({
                auto_print_fiscal_on_payment_methods: [],
                is_dispatch: false,
                sync_products_from_all_locations: false,
                sync_location_ids: []
              }, pos, {
                auto_print_fiscal_on_payment_methods: Array.isArray(pos.auto_print_fiscal_on_payment_methods)
                  ? pos.auto_print_fiscal_on_payment_methods
                  : []
              })
              // Set pos_type_id from integrated_bank_pos_id to populate dropdown selection
              if (this.model.integrated_bank_pos_id) {
                this.model.pos_type_id = this.model.integrated_bank_pos_id
              }
              if (!Array.isArray(this.model.allowed_fiscal_payment_methods)) {
                this.model.allowed_fiscal_payment_methods = []
              }
              if (!Array.isArray(this.model.not_allowed_order_statuses)) {
                this.model.not_allowed_order_statuses = []
              }
              this.model.is_dispatch = !!this.model.is_dispatch
              this.model.sync_products_from_all_locations = !!this.model.sync_products_from_all_locations
              if (!Array.isArray(this.model.sync_location_ids)) {
                this.model.sync_location_ids = []
              }
              if (this.model.is_dispatch) {
                this.pendingSyncLocationIds = this.model.sync_location_ids.slice()
                this.applyDispatchModeDefaults()
                this.applyPendingSyncLocationIds()
              } else {
                this.pendingSyncLocationIds = []
                this.model.sync_products_from_all_locations = false
                this.model.sync_location_ids = []
              }
              if (this.model.location_id) {
                this.changeLocation(true)
              }
            }
            this.loading = false
          })
        }

        this.locations = []
        let requestData = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }

        this.apiRequest('/get-locations', 'GET', requestData, (response) => {
          if (response.status) {
            this.locations = response.data
            this.applyPendingSyncLocationIds()
          }
          if (!id) {
            this.loading = false
          }
        })


        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/fiscal-printer', 'GET', data, response => {
          if (response.status === true) {
            this.fiscalPrinter = response.data.fiscalPrinter
          }
          this.$nextTick(() => {
            this.loading = false
          })
        })

        const dataCantar = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/cantar', 'GET', dataCantar, response => {
          if (response.status === true) {
            this.cantare = response.data.cantar
          }
          this.$nextTick(() => {
            this.loading = false
          })
        })
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      areAllDeliveryMethodsDisabled () {
        return !!(
          this.model.disable_eat_in &&
          this.model.disable_delivery &&
          this.model.disable_pick_up &&
          this.model.disable_drive_in
        )
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
            return
          }
          if (this.areAllDeliveryMethodsDisabled()) {
            swal({
              text: this.$t('settingTable.allDeliveryMethodsDisabled'),
              type: 'warning',
              showConfirmButton: true
            })
            return
          }
          this.saveTable()
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            if (errors[prop].length === 1) {
              this.errors.add(prop, errors[prop][0])
            } else {
              this.errors.add(prop, errors[prop])
            }
          } else {
            this.errors.add('error', errors[prop])
          }
        }
      },
      saveTable () {
        // Ensure integrated_bank_pos_name is synced with selected option before saving
        if (this.model.pos_type_id) {
          const selectedOption = this.posOptions.find(pos => pos.id === this.model.pos_type_id)
          if (selectedOption) {
            this.model.integrated_bank_pos_id = selectedOption.id
            this.model.integrated_bank_pos_name = selectedOption.name
          }
        }

        if (this.model.is_dispatch) {
          this.applyDispatchModeDefaults()
          this.pendingSyncLocationIds = Array.isArray(this.model.sync_location_ids)
            ? this.model.sync_location_ids.slice()
            : []
        } else {
          this.model.sync_products_from_all_locations = false
          this.model.sync_location_ids = []
          this.pendingSyncLocationIds = []
        }

        this.loading = true

        let data = {
          'token': this.$session.get('token'),
          'company_id': this.$session.get('selectedCompany'),
          'pos': this.model
        }

        var id = this.id || this.route.params.id
        let url = ''
        let request = ''
        if (id) {
          url = '/pos/' + id
          request = 'PUT'
        } else {
          url = '/pos/add'
          request = 'POST'
        }
        this.apiRequest(url, request, data, (response) => {
          if (response.status === true) {
            if (
              response.data &&
              response.data.pos &&
              Array.isArray(response.data.pos.sync_location_ids)
            ) {
              this.pendingSyncLocationIds = response.data.pos.sync_location_ids.slice()
              this.applyPendingSyncLocationIds()
            }
            const entityId = id || (response.data && response.data.pos && response.data.pos.id) || null
            this.trackAdminEvent('ADMIN_POS_UPDATE', 'pos', entityId, {
              pos_id: entityId,
              name: (this.model && this.model.name) || null,
              request: data,
              response: response
            })
            this.errors.clear()
            if (request === 'POST') {
              this.$bus.$emit('refresh')
              this.$bus.$emit('close-modal')
              // this.router.push('/pos/edit/' + response.data.pos.id)
            } else {
              this.backButton()
            }
            swal(
              {
                title: '',
                text: this.$t('settingTable.tableSave'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }
            )
          } else {
            this.handleErrors(response.errors)
          }
          this.loading = false
        })
      },
      deleteOrderScreen () {
        this.loadingReset = true
        var id = this.id || this.route.params.id
        var data = {
          company_id: this.$session.get('selectedCompany'),
          token: this.$session.get('token'),
          delete: true
        }
        this.apiRequest('/pos/' + id, 'DELETE', data, (response) => {
          if (response.status) {
            this.trackAdminEvent('ADMIN_POS_DELETED', 'pos', id, {
              pos_id: id,
              name: (this.model && this.model.name) || null
            })
            swal({'text': 'Saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
            this.backButton()
          } else {
            swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
          }
          this.loadingReset = false
        })
      },
      changeLocation (doNotEmptyModel = false) {
        if (!doNotEmptyModel) {
          this.model.table_maps_ids = []
        }
        let data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          location_id: this.model.location_id
        }
        this.loading = true
        this.apiRequest('/pos/all/map', 'GET', data, (response) => {
          if (response.status) {
            this.table_maps = response.data.table_maps
          }
          this.loading = false
        })
      },
      backButton () {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
        // this.router.push('/pos/tabs?tabIndex=1')
      },
      deleteToken () {
        let data = {
          'token': this.$session.get('token'),
          'company_id': this.$session.get('selectedCompany')
        }

        var id = this.id || this.route.params.id
        swal({
          type: 'question',
          title: this.$t('settingTable.deleteZoneTitle'),
          text: this.$t('settingTable.disableAuthInfo'),
          position: 'top-end',
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes'),
          cancelButtonText: this.$t('general.no'),
          allowOutsideClick: false
        }).then((result) => {
          this.apiRequest('/pos/' + id + '/delete-token', 'PUT', data, (response) => {
            this.model.token = null
          })
        })
      },
      updateColor (value) {
        this.model.background_color = value
      }
    }
  }
</script>
<style scoped lang="scss">
  .copy_link {
    margin-top: 10px;
    width: 100%;
  }
  .upload-demo input[type="file"]{ display: none; }
  .middle {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .pos-settings-group {
    margin-bottom: 8px;
    padding-bottom: 4px;
  }
  .pos-settings-group + .pos-settings-group {
    margin-top: 12px;
  }
  .section-title {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin: 0 0 12px;
    padding-bottom: 8px;
    border-bottom: 2px solid #e8e8e8;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .is-disabled {
    pointer-events: none;
    opacity: 0.7;
  }
</style>
<style>
  span.el-select__tags-text {
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PosSettings/pos/PosForm.vue